import React from 'react';
import PropTypes from 'prop-types';
import Team from 'records/Team';
import moment from 'moment';
import User from 'records/User';
import RepsListContainer from 'components/coaching/landing-pages/RepsListContainer';
import {List} from 'immutable';
import './CoachingPlansWidget.styl';
import withCoachingPlanWizard from 'components/coaching/wizard/withCoachingPlanWizard';
import PastPlansContainer from 'components/dashboard/PastPlansContainer';
// Need the styles of the now-defunct ManagerCoachingPage.js
import './ManagerCoachingPage.styl';
import scrollIntoView from 'dom-scroll-into-view';

class CoachingPlansWidget extends React.PureComponent {
  //
  // This is passed to the component above the PastPlansContainer
  // as a way for it to notify when PastPlansContainer should be
  // auto scrolled into view if needed.
  //
  // In other words, this should get called when it actually knows
  // the "final" layout so proper scrolling can occur.
  //
  autoScrollIfNecessary = () => {
    if (this.props.location?.query?.scrollToPreviouslyCoached === 'true') {
      setTimeout(() => {
        const domNode = this.pastPlansContainerRef;
        const rect = domNode.getBoundingClientRect();
        const isTopVisible = rect.bottom <= window.innerHeight;

        if (!isTopVisible) {
          scrollIntoView(domNode, window, {
            alignWithTop: true,
          });
        }
      }, 1000);
    }
  };
  render() {
    return (
      <div className="standalone-widget-wrapper">
        <div className="coaching-plans-widget">
          <RepsListContainer
            adHocNoCallOnly={true}
            plansLimit={this.props.plansLimit}
            showMoreLink={this.props.showMoreLink}
            onCreatePlan={this.props.onCreatePlan}
            onEditPlan={this.props.onEditPlan}
            authUser={this.props.authUser}
            managerId={this.props.managerId}
            manager={this.props.manager}
            selectedTeam={this.props.selectedTeam}
            adminId={this.props.adminId}
            coachId={this.props.coachId}
            startDate={this.props.startDate}
            endDate={this.props.endDate}
            isManagerLoggedIn={this.props.isManagerLoggedIn}
            directReportsUserIds={this.props.directReportsUserIds}
            refreshCoachingData={this.props.refreshCoachingData}
            fromPath={this.props.fromPath}
            suppressToggle={this.props.suppressToggle}
            suppressLoading={this.props.suppressLoading}
            autoScrollIfNecessary={this.autoScrollIfNecessary}
          />
          {!this.props.isSummary && (
            <div ref={r => (this.pastPlansContainerRef = r)}>
              <PastPlansContainer
                coach={this.props.coach ? this.props.coach : this.props.manager}
                coachId={this.props.coachId ? this.props.coachId : this.props.managerId}
                dashCoachId={this.props.coachId}
                managerId={this.props.managerId}
                adminId={this.props.adminId}
                startDate={this.props.startDate}
                endDate={this.props.endDate}
                isManagerLoggedIn={this.props.isManagerLoggedIn}
                fromPath={this.props.fromPath}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withCoachingPlanWizard(CoachingPlansWidget);

CoachingPlansWidget.propTypes = {
  selectedTeam: PropTypes.instanceOf(Team),
  startDate: PropTypes.instanceOf(moment),
  endDate: PropTypes.instanceOf(moment),
  authUser: PropTypes.instanceOf(User),
  manager: PropTypes.instanceOf(User),
  isManagerLoggedIn: PropTypes.bool,
  directReportsUserIds: PropTypes.instanceOf(List),
  managerId: PropTypes.string,
  refreshCoachingData: PropTypes.func,
};
